module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAATDPpdAAAAr0lEQVQoFWNgoDVgnDVrVvf///8LgBaxYLHsAQsLi0dycvJNoBrGOXPm6DLhUQzSr/Dnzx///fv3s8yePXvFv3//zoNMxWYysmVPbt++PQVocBhIEK9iRkbG60A1F4GKl8JMYIIxcNCSTExM3EC5PzB5vBqAJgsA3e0M1FSPrOETjIODfpmamtoGdF4XEH8F+SEeyIgDmobNPxcEBAQWggxKS0srX7RoURMOQ6koDADbokCWSOVw1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/NotaryDetail/bfl.png
// module id = dIpW
// module chunks = 0